import { render } from "./ExportGame.vue?vue&type=template&id=920c183c"
import script from "./ExportGame.vue?vue&type=script&lang=js"
export * from "./ExportGame.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__